import React from 'react'
import { useTheme } from '@mui/material'
import { Edit2 } from 'iconsax-react'

import Tooltip from '../../../atoms/Tooltip'

import { MessageDraft, checkDraft } from '@SonarCX/lib/idb'
import Signal from '@SonarCX/lib/signal'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'
import useStyles from './styles'

type DraftInfoProps = {
  session: string
  selected: boolean
}

const DraftInfo: React.FC<DraftInfoProps> = ({ session, selected }) => {
  const theme = useTheme()

  const { user } = useEnvironment()

  const [draft, setDraft] = React.useState<MessageDraft>(null)
  const userID = React.useMemo(() => user?.id, [user])
  const [message, files] = React.useMemo(() => {
    if (!draft) {
      return ['', '']
    }

    const message = draft.message.replace(/\n+/gm, ' ').trim()
    const files = draft.file.length
    return [message, files > 0 ? `${files} file${files === 1 ? '' : 's'}` : '']
  }, [draft])

  const classes = useStyles()

  // Wait for signal to update
  React.useEffect(() => {
    const checkStoredDraft = async (changed: string) => {
      if (changed !== session) {
        return
      }

      if (!userID) {
        return
      }

      const storedDraft = await checkDraft(userID, session)
      setDraft(storedDraft)
    }

    window.SONAR_SIGNAL.on(Signal.draft, checkStoredDraft)

    return () => {
      window.SONAR_SIGNAL.off(Signal.draft, checkStoredDraft)
    }
  }, [session, userID])

  if (!draft || selected) {
    return null
  }

  if (!message && !files) {
    return null
  }

  return (
    <Tooltip
      title={
        <div className={classes.root}>
          <div className={classes.title}>Draft</div>
          {message && <div>"{message}"</div>}
          {files && <div>{files}</div>}
        </div>
      }
    >
      <div>
        <Edit2 size={theme.size.base} color={theme.palette.primary.main} />
      </div>
    </Tooltip>
  )
}

export default DraftInfo
